// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { GanttPredecessorDependenciesFragmentDoc } from '../gantt/ScheduleGantt.generated';
import { ScheduleSettingDetailsFragmentDoc } from '../../../../fragments/circularFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SetDateViaPredecessorModalQueryVariables = Types.Exact<{
  taskId: Types.Scalars['ID']['input'];
}>;


export type SetDateViaPredecessorModalQuery = { __typename?: 'Query', scheduleTask: { __typename?: 'ScheduleTask', id: string, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number, calendarProgress: number }, predecessorDependencies: Array<{ __typename?: 'ScheduleTaskDependency', id: string, type: Types.TaskDependencyType, lagInDays: number, predecessor: { __typename?: 'ScheduleTask', id: string, name: string, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], durationInDays: number } } }>, schedule: { __typename?: 'Schedule', id: string, scheduleSetting?: { __typename?: 'ScheduleSetting', id: string, workingDays: Array<Types.DayOfWeek>, exceptions?: any | null | undefined } | null | undefined } } };


export const SetDateViaPredecessorModalDocument = gql`
    query SetDateViaPredecessorModal($taskId: ID!) {
  scheduleTask(id: $taskId) {
    id
    interval {
      startDate
      endDate
      durationInDays
      calendarProgress
    }
    predecessorDependencies {
      ...GanttPredecessorDependencies
    }
    schedule {
      id
      scheduleSetting {
        ...ScheduleSettingDetails
      }
    }
  }
}
    ${GanttPredecessorDependenciesFragmentDoc}
${ScheduleSettingDetailsFragmentDoc}`;

/**
 * __useSetDateViaPredecessorModalQuery__
 *
 * To run a query within a React component, call `useSetDateViaPredecessorModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSetDateViaPredecessorModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSetDateViaPredecessorModalQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useSetDateViaPredecessorModalQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables> & ({ variables: SetDateViaPredecessorModalQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>(SetDateViaPredecessorModalDocument, options);
      }
export function useSetDateViaPredecessorModalLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>(SetDateViaPredecessorModalDocument, options);
        }
// @ts-ignore
export function useSetDateViaPredecessorModalSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>;
export function useSetDateViaPredecessorModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SetDateViaPredecessorModalQuery | undefined, SetDateViaPredecessorModalQueryVariables>;
export function useSetDateViaPredecessorModalSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>(SetDateViaPredecessorModalDocument, options);
        }
export type SetDateViaPredecessorModalQueryHookResult = ReturnType<typeof useSetDateViaPredecessorModalQuery>;
export type SetDateViaPredecessorModalLazyQueryHookResult = ReturnType<typeof useSetDateViaPredecessorModalLazyQuery>;
export type SetDateViaPredecessorModalSuspenseQueryHookResult = ReturnType<typeof useSetDateViaPredecessorModalSuspenseQuery>;
export type SetDateViaPredecessorModalQueryResult = ApolloReactCommon.QueryResult<SetDateViaPredecessorModalQuery, SetDateViaPredecessorModalQueryVariables>;